import { connect } from 'react-redux';
import { ESaleStatus } from '../../../../types/filters';
import { SALE_STATUSES } from '../../../../constants/filters';
import { TIndexableObject } from '../../../../interfaces/villages';
import { changeSaleStatusFilter } from '../../../../store/filters/actions';
import { mapDispatchToPropsCreator, mapStateToPropsCreator } from '../creators';
import { createExtraFilter, IExtraFilterProps } from '../helpers';

export const SaleStatusLongNames: TIndexableObject = {
  closed: 'Статус продаж: завершены',
  opened: 'Статус продаж: открыты',
  pending: 'Статус продаж: ожидание',
};

const SaleStatusFilter = createExtraFilter<ESaleStatus>(SALE_STATUSES);

type TSaleStatusFilterProps = IExtraFilterProps<ESaleStatus>;

export const SaleStatusFilterContainer = connect<
  Pick<TSaleStatusFilterProps, 'selected'>,
  Pick<TSaleStatusFilterProps, 'toggle'>
>(
  mapStateToPropsCreator<ESaleStatus>('saleStatus'),
  mapDispatchToPropsCreator<ESaleStatus>(changeSaleStatusFilter),
)(SaleStatusFilter);
